var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTopSpeed = function SvgTopSpeed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    d: "M10.46 15.513q.626.627 1.577.59t1.376-.69l5.607-8.41-8.41 5.607q-.65.45-.713 1.364-.062.912.563 1.54M5.104 20.02a2.2 2.2 0 0 1-1.014-.239 1.8 1.8 0 0 1-.738-.713 11.2 11.2 0 0 1-1.002-2.44A9.7 9.7 0 0 1 2 14.013q0-2.078.789-3.905a10.1 10.1 0 0 1 2.14-3.179q1.35-1.35 3.178-2.14A9.8 9.8 0 0 1 12.012 4q2.052 0 3.854.776a10.12 10.12 0 0 1 5.306 5.244 9.6 9.6 0 0 1 .826 3.842q.026 1.376-.312 2.69a9.8 9.8 0 0 1-1.04 2.515 1.8 1.8 0 0 1-.737.714 2.2 2.2 0 0 1-1.015.238z"
  })));
};
export default SvgTopSpeed;